export const HTTP_HEADER_CONTENT_TYPE = "Content-Type";
export const CONTENT_TYPE_APPLICATION_JSON = "application/json";
export const HTTP_STATUS_NO_CONTENT = 204;
